import React from 'react';
import {
  Box,
  Paper,
  Typography,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import attLogo from '../img/brand/att-logo.png';
import tmoLogo from '../img/brand/T-Mobile_Logo.png';

const formatMetric = (value) => {
  if (value === null || value === undefined || value === '') return '-';
  const numeric = Number(value);
  if (Number.isFinite(numeric)) {
    return Number.isInteger(numeric) ? numeric.toString() : numeric.toFixed(2);
  }
  return String(value);
};

const formatBytes = (value) => {
  if (value === null || value === undefined || value === '') return '-';
  const bytes = Number(value);
  if (!Number.isFinite(bytes)) return '-';

  const absBytes = Math.abs(bytes);
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  let unitIndex = 0;
  let scaled = absBytes;

  while (scaled >= 1024 && unitIndex < units.length - 1) {
    scaled /= 1024;
    unitIndex += 1;
  }

  const sign = bytes < 0 ? '-' : '';
  const decimals = scaled >= 100 ? 0 : scaled >= 10 ? 1 : 2;
  return `${sign}${scaled.toFixed(decimals)} ${units[unitIndex]}`;
};

const BuildingUserDetailPanel = ({
  building,
  metrics,
  onClose,
  style = {}
}) => {
  if (!building) return null;

  const rows = [
    {
      label: "Today's Users",
      type: 'count',
      att: metrics?.attCurUsers,
      tmo: metrics?.tmoCurUsers,
      total: metrics?.totalCurUsers
    },
    {
      label: "Today's Rx",
      type: 'bytes',
      att: metrics?.attCurRx,
      tmo: metrics?.tmoCurRx,
      total: metrics?.totalCurRx
    },
    {
      label: "Today's Tx",
      type: 'bytes',
      att: metrics?.attCurTx,
      tmo: metrics?.tmoCurTx,
      total: metrics?.totalCurTx
    },
    {
      label: "Yesterday's Users",
      type: 'count',
      att: metrics?.attHistUsers,
      tmo: metrics?.tmoHistUsers,
      total: metrics?.totalHistUsers
    },
    {
      label: "Yesterday's Rx",
      type: 'bytes',
      att: metrics?.attHistRx,
      tmo: metrics?.tmoHistRx,
      total: metrics?.totalHistRx
    },
    {
      label: "Yesterday's Tx",
      type: 'bytes',
      att: metrics?.attHistTx,
      tmo: metrics?.tmoHistTx,
      total: metrics?.totalHistTx
    }
  ];

  return (
    <Paper
      elevation={8}
      sx={{
        position: 'absolute',
        bottom: 24,
        right: { xs: 24, sm: 420 },
        width: { xs: '90%', sm: 380 },
        maxHeight: '70vh',
        overflow: 'hidden',
        zIndex: 110,
        backgroundColor: '#fff',
        borderRadius: 2,
        ...style
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          p: 2,
          borderBottom: '1px solid #e0e0e0',
          backgroundColor: '#0D2F66'
        }}
      >
        <Typography variant="subtitle1" sx={{ color: '#fff', fontWeight: 600 }}>
          {building.name} User Details
        </Typography>
        <IconButton size="small" onClick={onClose} sx={{ color: '#fff' }}>
          <CloseIcon />
        </IconButton>
      </Box>

      <Box sx={{ p: 2 }}>
        <TableContainer sx={{ overflowX: 'hidden' }}>
          <Table
            size="small"
            aria-label="user details metrics"
            sx={{
              tableLayout: 'fixed',
              width: '100%',
              '& .MuiTableCell-root': {
                px: 0.75,
                py: 0.7,
                fontSize: '0.9rem',
                lineHeight: 1.2,
                whiteSpace: 'normal',
                wordBreak: 'break-word'
              }
            }}
          >
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 700, color: '#0A2240', width: '34%' }}>Metric</TableCell>
                <TableCell align="center" sx={{ width: '22%' }}>
                  <Box component="img" src={attLogo} alt="AT&T" sx={{ height: 18, maxWidth: 54, objectFit: 'contain' }} />
                </TableCell>
                <TableCell align="center" sx={{ width: '22%' }}>
                  <Box component="img" src={tmoLogo} alt="T-Mobile" sx={{ height: 18, maxWidth: 54, objectFit: 'contain' }} />
                </TableCell>
                <TableCell align="center" sx={{ fontWeight: 700, color: '#0A2240', width: '22%' }}>
                  Total
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row) => (
                <TableRow key={row.label}>
                  <TableCell sx={{ color: '#425466' }}>{row.label}</TableCell>
                  <TableCell align="center" sx={{ fontWeight: 600 }}>
                    {row.type === 'bytes' ? formatBytes(row.att) : formatMetric(row.att)}
                  </TableCell>
                  <TableCell align="center" sx={{ fontWeight: 600 }}>
                    {row.type === 'bytes' ? formatBytes(row.tmo) : formatMetric(row.tmo)}
                  </TableCell>
                  <TableCell align="center" sx={{ fontWeight: 700, color: '#0D2F66' }}>
                    {row.type === 'bytes' ? formatBytes(row.total) : formatMetric(row.total)}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Paper>
  );
};

export default BuildingUserDetailPanel;
